// extracted by mini-css-extract-plugin
export default {"add-task-btn":"AddNewTaskDialog_add-task-btn__BE7Du","cancel-btn":"AddNewTaskDialog_cancel-btn__Fsitz","submit-btn":"AddNewTaskDialog_submit-btn__fOnjv"};